import { render, staticRenderFns } from "./DOTSExport.vue?vue&type=template&id=618ec9da&scoped=true"
import script from "./DOTSExport.vue?vue&type=script&lang=js"
export * from "./DOTSExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ec9da",
  null
  
)

export default component.exports